import Seo from '@/components/shared/Seo';
import MobileMenu from '@/components/shared/MobileMenu';
import FullScreenGuard from '@/components/auth/FullScreenGuard';
import { Button } from '@/components/ui/button';
import PeopleContent from '@/components/explore/desktop/people/PeopleContent';
import Link from 'next/link';
type TradePageProps = {};
type TradePageRef = React.ForwardedRef<HTMLDivElement>;
const modes = ['Feed', 'Following', 'Followers', 'Requests'];
export type TFeedMode = 'Feed' | 'Following' | 'Followers' | 'Requests';
export default function FeedPage(props: TradePageProps, ref: TradePageRef) {
  return <div className='bg-genius-indigo h-full max-h-screen ' data-sentry-component="FeedPage" data-sentry-source-file="index.tsx">
      <Seo noindex nofollow title='Feed • Follow what your friend are doing' data-sentry-element="Seo" data-sentry-source-file="index.tsx" />
      <FullScreenGuard data-sentry-element="FullScreenGuard" data-sentry-source-file="index.tsx">
        <div className='w-full ta-c px-3'>
          <Link className='w-full' href="/refer" data-sentry-element="Link" data-sentry-source-file="index.tsx">
            <Button className='rounded-full w-full h-[56px] my-4' variant='pink' data-sentry-element="Button" data-sentry-source-file="index.tsx">
              Refer Friends
            </Button>
          </Link>
        </div>
        <div>
          <PeopleContent data-sentry-element="PeopleContent" data-sentry-source-file="index.tsx" />
        </div>
        <MobileMenu data-sentry-element="MobileMenu" data-sentry-source-file="index.tsx" />
      </FullScreenGuard>
    </div>;
}